<template>
  <svg
    :id="uniqueId"
    :class="classnames"
    :fill="`currentColor`"
    :height="getHeight"
    :viewBox="`0 0 18 12`"
    :width="getWidth"
  >
    <g transform="translate(-286.000000, -158.000000)">
      <path d="M286,158 L304,158 L304,160 L286,160 L286,158 Z M286,163 L304,163 L304,165 L286,165 L286,163 Z M286,168 L304,168 L304,170 L286,170 L286,168 Z" />
    </g>
  </svg>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'svg-icon-hamburger'

  export default {
    name: 'SvgIconHamburger',
    mixins: [ bem ],
    props: {
      height: {
        default: '12',
        type: String
      },
      width: {
        default: '18',
        type: String
      }
    },
    data () {
      return {}
    },
    computed: {
      getHeight: function () {
        const height = `${this.height}px`

        return height
      },
      getWidth: function () {
        const width = `${this.width}px`

        return width
      }
    },
    created: function () {
      this.namespace = namespace
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/svgs/SvgIconHamburger.vue